import { TopInnoTracks, NavBarFinal, FooterFinal } from "../components/index";

export const TopInnovator = () => {
  document.title = "Florida Venture Summit | Top Innovator";
  return (
    <div style={{ backgroundColor: "white" }}>
      <NavBarFinal />
      <TopInnoTracks />
      <FooterFinal />
    </div>
  );
};


//old component

// // import { useState } from "react";
// // import TextField from "@mui/material/TextField";
// // import Stack from "@mui/material/Stack";
// // import { Footer } from "../../../components/index";
// // import Button from "@mui/material/Button";
// // import SendIcon from "@mui/icons-material/Send";
// // import Radio from "@mui/material/Radio";
// // import RadioGroup from "@mui/material/RadioGroup";
// // import FormControlLabel from "@mui/material/FormControlLabel";
// // import FormControl from "@mui/material/FormControl";
// // import FormLabel from "@mui/material/FormLabel";
// // import InputLabel from "@mui/material/InputLabel";
// // import MenuItem from "@mui/material/MenuItem";
// // import FormHelperText from "@mui/material/FormHelperText";
// // import Select from "@mui/material/Select";
// import { TopInnoTracks, NavBarFinal, FooterFinal } from "../components/index";

// export const TopInnovator = () => {
//   document.title = "Florida Venture Summit | Top Innovator";

//   // const [industry, setIndustry] = useState("");
//   // const [stage, setStage] = useState("");
//   // const [reference, setReference] = useState("");
//   // const [hasWebsite, setHasWebsite] = useState(true);
//   // options for Industry dropdown
//   // const industryArr = [
//   //   "AgriTech/FoodTech",
//   //   "BioTech/Pharma",
//   //   "CleanTech",
//   //   "Consumer Products",
//   //   "Cyber Security",
//   //   "EdTech",
//   //   "FinTech",
//   //   "Gaming",
//   //   "Hardware",
//   //   "Healthcare IT",
//   //   "Life Sciences/Healthcare",
//   //   "MedTech",
//   //   "Mobile/Communications",
//   //   "Software/IT",
//   //   "Tech",
//   //   "Wearables",
//   //   "Web/Internet",
//   //   "Other",
//   // ];
//   // options for Referred By dropdown
//   // const referredArr = [
//   //   "Allstate Strategic Ventures",
//   //   "APX",
//   //   "Asociacion de Fintech e Insurtech de Espana",
//   //   "Bankless Times",
//   //   "BayMed Venture Partners",
//   //   "Bonjour Startup Montreal",
//   //   "BRITE Energy Innovators",
//   //   "Business and Industry Association of New Hampshire",
//   //   "Cambridge Cleantech",
//   //   "Canadian Black Chamber of Commerce",
//   //   "Cartika",
//   //   "Centre for Social Innovation",
//   //   "Chinese Biopharmaceutical Association-USA",
//   //   "Chykalophia",
//   //   "CleanTech.org",
//   //   "Cleantech Commons at Trent University",
//   //   "Connection Silicon Valley",
//   //   "Cryptonewsz",
//   //   "Enterprising Women",
//   //   "Equal Space",
//   //   "European American Enterprise Council",
//   //   "Family Office Networks",
//   //   "Financial Data and Technology Association",
//   //   "FinTech Australia",
//   //   "Fintech Finance",
//   //   "Fintech Guatemala",
//   //   "FinTechCity",
//   //   "FintechNA",
//   //   "Fintek.pl",
//   //   "FinTEx and PCN Capital",
//   //   "Foster Buerk Center for Entrepreneurship",
//   //   "France FinTech",
//   //   "Frankfurt Main Finance",
//   //   "FreeMind Consultants",
//   //   "German Accelerator",
//   //   "Hong Kong Wireless Technology Industry Association",
//   //   "Innovate BC",
//   //   "InsurTech360",
//   //   "Israel Startup Network",
//   //   "Japan External Trade Organization",
//   //   "Jumpstart",
//   //   "KC Wisdom",
//   //   "LA Fintech",
//   //   "McCarter & English LLP",
//   //   "McDermott Will & Emery LLP",
//   //   "Mongotel",
//   //   "National Renewable Energy Laboratory",
//   //   "National Veteran Owned Business Association",
//   //   "North Sacramento Chamber of Commerce",
//   //   "OneValley",
//   //   "Oxfordshire Greentech",
//   //   "Plug and Play Tech Center",
//   //   "Shanghai Multimedia Industry Association",
//   //   "Startup Association of India",
//   //   "Startup Garage",
//   //   "Startup Heart",
//   //   "Startup One Stop",
//   //   "StartupIreland",
//   //   "StartupReporter",
//   //   "Startups Magazine",
//   //   "The Carfang Group",
//   //   "The Fintech Times",
//   //   "The Lab Miami",
//   //   "Today’s Medical Developments",
//   //   "Troutman Pepper LLP",
//   //   "US Angels",
//   //   "Veterans Business Network",
//   //   "Women Business Collaborative",
//   //   "Women in Telecoms and Technology",
//   //   "Women Tech Founders",
//   //   "YBF Ventures",
//   //   "Preston Michaels",
//   //   "Google",
//   //   "Other",
//   //   "None",
//   // ];

//   return (
//     <div style={{ backgroundColor: "white" }}>
//       <NavBarFinal />

//       {/* <form
//         style={{
//           justifyContent: "center",
//           textAlign: "center",
//           marginRight: "15vw",
//           marginLeft: "15vw",
//           marginBottom: "5vh",
//           padding: "1rem",
//           backgroundColor: "white",
//           borderRadius: "10px",
//         }}
//       >
//         <Stack spacing={2}>
//           <TextField
//             id="outlined-basic"
//             label="First Name"
//             variant="outlined"
//           />
//           <TextField id="outlined-basic" label="Last Name" variant="outlined" />
//           <TextField id="outlined-basic" label="Job Title" variant="outlined" />
//           <TextField
//             id="outlined-basic"
//             label="Company Name"
//             variant="outlined"
//           />
//           <TextField id="outlined-basic" label="Email" variant="outlined" />
//           <FormControl sx={{ m: 1, minWidth: 120 }}>
//             <InputLabel id="demo-simple-select-helper-label">
//               Industry
//             </InputLabel>
//             <Select
//               labelId="demo-simple-select-helper-label"
//               id="demo-simple-select-helper"
//               value={industry}
//               label="Industry"
//               onChange={(e) => setIndustry(e.target.value)}
//             >
//               {industryArr.map((industry, i)=><MenuItem key={i} value={industry}>{industry}</MenuItem>)}
              
//             </Select>
//           </FormControl>
//           <FormControl component="fieldset">
//             <FormLabel component="legend" style={{ textAlign: "left" }}>
//               Company Website
//             </FormLabel>
//             <RadioGroup
//               aria-label="gender"
//               defaultValue="female"
//               name="radio-buttons-group"
//             >
//               <FormControlLabel
//                 value="female"
//                 control={<Radio />}
//                 label="I have a company website"
//                 onClick={() => setHasWebsite(true)}
//               />
//               <FormControlLabel
//                 value="male"
//                 control={<Radio />}
//                 label="I do not have a company website"
//                 onClick={() => setHasWebsite(false)}
//               />
//             </RadioGroup>
//           </FormControl>
//           {hasWebsite == true ? (
//             <TextField
//               id="outlined-basic"
//               label="Company Website"
//               variant="outlined"
//             />
//           ) : (
//             <TextField
//               id="outlined-basic"
//               label="Social Media"
//               variant="outlined"
//             />
//           )}
//           <FormControl sx={{ m: 1, minWidth: 120 }}>
//             <InputLabel id="demo-simple-select-helper-label">
//               Company Stage
//             </InputLabel>
//             <Select
//               labelId="demo-simple-select-helper-label"
//               id="demo-simple-select-helper"
//               value={stage}
//               label="Company Stage"
//               onChange={e => setStage(e.target.value)}
//             >
//               <MenuItem value={'Seeking Angel Round'}>Seeking Angel/Seed Round</MenuItem>
//               <MenuItem value={'Seeking Series A'}>Seeking Series A</MenuItem>
//               <MenuItem value={'Seeking Series B'}>Seeking Series B</MenuItem>
//               <MenuItem value={'Seeking Series C'}>Seeking Series C</MenuItem>
//             </Select>
//           </FormControl>
//           <FormControl sx={{ m: 1, minWidth: 120 }}>
//             <InputLabel id="demo-simple-select-helper-label">
//               Referred by
//             </InputLabel>
//             <Select
//               labelId="demo-simple-select-helper-label"
//               id="demo-simple-select-helper"
//               value={reference}
//               label="Reference"
//               onChange={(e) => setReference(e.target.value)}
//             >
//              { referredArr.map((item, i)=> <MenuItem key={i} value={item}>{item}</MenuItem>)}
//             </Select>
//           </FormControl>
//           <div>
//             <Button
//               variant="contained"
//               style={{
//                 width: "fit-content",
//                 textAlign: "center",
//                 paddingRight: "2vw",
//                 paddingLeft: "2vw",
//               }}
//               endIcon={<SendIcon />}
//             >
//               Send
//             </Button>
//           </div>
//         </Stack>
//       </form> */}

//       <TopInnoTracks />
//       <FooterFinal />
//     </div>
//   );
// };
